<template>
    <div>
        <sweet-modal ref="captionModal" :modal-theme="$vuetify.theme.dark === true ? 'dark' : 'light'" :overlay-theme="$vuetify.theme.dark === true ? 'light' : 'dark'" blocking>

            <v-skeleton-loader v-show="isBusy"
                               type="image"></v-skeleton-loader>

            <div v-show="!isBusy" v-html="htmlDescription" class="caption-container">
            </div>
        </sweet-modal>
    </div>
</template>

<script>
    import HelpCaptionService from "../../services/helpCaptionService";
    import { EventBus } from '../../event/event-bus.js';

    export default {
        data() {
            return {
                isBusy: false,
                accessToken: "",
                htmlDescription: ""
            }
        },
        created() {
            EventBus.$on('emit-caption', event => {
                this.$refs.captionModal.open();
                this.getHelpCaptionByName(event);
            });
        },
        methods: {
            async getHelpCaptionByName(name) {
                this.accessToken = this.$auth.getAccessToken();
                this.$refs.captionModal.open();
                this.isBusy = true;

                const result = await HelpCaptionService.getHelpCaptionByName(name, this.accessToken);

                if (result?.htmlDescription) {
                    this.htmlDescription = result.htmlDescription;
                }
                else {
                    this.$refs.captionModal.close();
                }

                this.isBusy = false;
            }
        }
    };
</script>
